import React from "react";
import { Box, CircularProgress } from "@mui/material";

const AppLoader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#fafafa",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        sx={{ color: "rgba(36, 139, 112, 1)" }}
        size={60}
        thickness={4}
      />
    </Box>
  );
};

export default AppLoader;
